(function(angular){
	'use strict';

	angular
		.module('authModule')
		.controller('additionalResetSecurityQuestionsController', [
			'$timeout',
			'globalConfig',
			'urlFactory',
			AdditionalResetSecurityQuestionsController
		]);

	function AdditionalResetSecurityQuestionsController(
		$timeout,
		globalConfig,
		urlFactory
	){
		var additionalResetSecurityQuestions = this;

		additionalResetSecurityQuestions.$onInit = function() {
			angular.extend(additionalResetSecurityQuestions, globalConfig);
			
			if(angular.isDefined(additionalResetSecurityQuestions.serverSideErrorMap)) {
				$timeout(function() {
					urlFactory.handleServerValidation(
						additionalResetSecurityQuestions.additionalResetSecurityQuestionsForm,
						urlFactory.spoofApiError(additionalResetSecurityQuestions.serverSideErrorMap)
					);
				}, 100);
			}
		};
	}
})(window.angular);